
<p-dialog header="Detail Viewer" [(visible)]="isShowDialog" [modal]="true"
   [contentStyle]="{minHeight: '200px'}" [style]="{width: '96%', minWidth: '500px'}"
  [maximizable]="true" closeIcon="pi pi-times"
  appendTo="body" showEffect="fade"
  (onHide)="closeDialog.emit(true)">
  <div class="viewer-body">
      <div class="col-xs-12 col-lg-12 col-md-12 col-sm-12">
          <form #workFlow="ngForm">
              <div class="col-xs-4 col-lg-4 col-md-4 box-border min-hg-150  mg-b-11">
                  <label for="workFlow" class="head-color">Work Flow</label>
                  <div class="row mg-b-11">
                    <div class="col-xs-4 col-lg-4 col-md-4">
                      <label for="status">Status:</label>
                    </div>
                    <div class="col-xs-8 col-lg-8 col-md-8">
                      <p-select styleClass="drp-color-style" [options]="status" placeholder="Select Status"
                        [(ngModel)]="this.updateStatus.status" required name="status" id="status"></p-select>
                    </div>
            
                  </div>
                  <div class="row mg-b-11">
                    <div class="col-xs-4 col-lg-4 col-md-4">
                      <label for="AssignedTo">Assigned To:</label>
                    </div>
                    <div class="col-xs-8 col-lg-8 col-md-8">
                      <p-select required styleClass="drp-color-style" [options]="userList" [(ngModel)]="selectedUser"
                      name="userList" id="userList" placeholder="Select User">
                      </p-select>
                    </div>
                  </div>
                  <div class="row mg-b-11">
                    <div class="col-xs-4 col-lg-4 col-md-4">
                      <label for="comment">Comment :</label>
                    </div>
                    <div class="col-xs-8 col-lg-8 col-md-8">
                      <input class="width-100" [(ngModel)]="this.updateStatus.comment" required name="comment" id="comment">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-4 col-lg-4 col-md-4">
            
                    </div>
                    <div class="col-xs-8 col-lg-8 col-md-8">
                         <button pButton id="btn_upload" type="button" 
                         label="Upload" class="button pull-right cls-button btnStyle">Upload</button>

                         <button pButton id="btn_update" type="button" [disabled]="workFlow.invalid"
                         label="Upload" class="button pull-right cls-button btnStyle" (click)="updateClientDataStaus()">Update</button>
                       
                    </div>
                  </div>
                </div>
          </form>
         
          <div class="col-xs-8 col-lg-8 col-md-8 box-border min-hg-150">
            <div class="row"> <label for="activity" class="head-color"> Activity</label></div>
      
            <div class="row">
              <p-table [columns]="cols" [value]="activityDetails" [paginator]="true" [rows]="3"
              [totalRecords]="totalRecords" [lazy]="true">
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    @for(col of columns; track col.header + '-'+ $index;) {
                    <th id="colHeader">
                      {{col.header}}
                    </th>
                    }
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                  <tr>
                    @for(col of columns; track col.field + '-'+ $index;) {
                    <td>
                      {{rowData[col.field]}}
                    </td>
                    }
                  </tr>
                </ng-template>
                <ng-template pTemplate="paginatorright">
                  Total Records: {{activityDetails.length == 0? 0 : activityDetails.length}}
      
                </ng-template>
                <ng-template pTemplate="paginatorleft">
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>        
        <div class="card flex justify-content-center">
          <p-accordion [multiple]="true" [value]="['0','1']">
            <p-accordion-panel value="0">
               <p-accordion-header><span class="headerText">Details Data</span></p-accordion-header>
                <p-accordion-content>
                <div class="div-scroll">
                  <ng-container>
                    <br>
                    <h2><span>Exception</span></h2>
                    <mat-form-field  [style.width.px]=220>
                      <mat-label>Order Date Time</mat-label>
                      <input matInput placeholder="Order Date Time" [(ngModel)]="selectedRow.OrderDateTime" disabled>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Exception Type</mat-label>
                      <input matInput placeholder="Exception Type" disabled [(ngModel)]="selectedRow.ExceptionType">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Exception</mat-label>
                      <input matInput placeholder="Exception" disabled [(ngModel)]="selectedRow.Exception">
                    </mat-form-field>
          
                    <mat-form-field>
                      <mat-label>Status</mat-label>
                      <input matInput placeholder="status" disabled [(ngModel)]="selectedRow.Status">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Owner</mat-label>
                      <input matInput placeholder="Owner" disabled [(ngModel)]="selectedRow.Owner">
                    </mat-form-field>
          
                    <mat-form-field>
                      <mat-label>Comments</mat-label>
                      <input matInput placeholder="Comments" disabled [(ngModel)]="selectedRow.Comments">
                    </mat-form-field>
                  </ng-container>
                  <ng-container>
                    <h2><span>Order Data</span></h2>
                    <mat-form-field>
                      <mat-label>Symbol</mat-label>
                      <input matInput placeholder="Symbol" disabled [(ngModel)]="selectedRow.Symbol">
                    </mat-form-field>
          
                    <mat-form-field>
                      <mat-label>Buy/Sell Code</mat-label>
                      <input matInput placeholder="Buy/sell code" disabled [(ngModel)]="selectedRow.BuySellCode">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Quantity</mat-label>
                      <input matInput placeholder="Quantity" disabled [(ngModel)]="selectedRow.Quantity">
                    </mat-form-field>
          
                    <mat-form-field>
                      <mat-label>Price Type</mat-label>
                      <input matInput placeholder="Price Type" disabled [(ngModel)]="selectedRow.PriceType">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Limit Price</mat-label>
                      <input matInput placeholder="Limit Price" disabled [(ngModel)]="selectedRow.LimitPrice">
                    </mat-form-field>
          
                    <mat-form-field>
                      <mat-label>Time In Force</mat-label>
                      <input matInput placeholder="Time In Force" disabled [(ngModel)]="selectedRow.TimeInForce">
                    </mat-form-field>
          
                    <mat-form-field [style.width.px]=250>
                      <mat-label>Expiry Date</mat-label>
                      <input matInput placeholder="Expiry Date" disabled [(ngModel)]="selectedRow.ExpiryDate">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Quantity</mat-label>
                      <input matInput placeholder="Quantity" disabled [(ngModel)]="selectedRow.Quantity">
                    </mat-form-field>
          
                    <mat-form-field [style.width.px]=250>
                      <mat-label>Expiry Time</mat-label>
                      <input matInput placeholder="Expiry Time" disabled [(ngModel)]="selectedRow.ExpiryTime">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Ord Bid</mat-label>
                      <input matInput placeholder="Ord Bid" disabled [(ngModel)]="selectedRow.OrdBid">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Ord Ask</mat-label>
                      <input matInput placeholder="Ord Ask" disabled [(ngModel)]="selectedRow.OrdAsk">
                    </mat-form-field>
          
                    <mat-form-field>
                      <mat-label>Firm MPID</mat-label>
                      <input matInput placeholder="Firm MPID" disabled [(ngModel)]="selectedRow.FirmMPID">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Contra ID</mat-label>
                      <input matInput placeholder="Contra ID" disabled [(ngModel)]="selectedRow.ContraID">
                    </mat-form-field>
          
                    <mat-form-field>
                      <mat-label>Contra Acct</mat-label>
                      <input matInput placeholder="Contra Acct" disabled [(ngModel)]="selectedRow.ContraAcct">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Locate Info</mat-label>
                      <input matInput placeholder="Locate Info" disabled [(ngModel)]="selectedRow.LocateInfo">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Acct Restrict</mat-label>
                      <input matInput placeholder="Acct Restrict" disabled [(ngModel)]="selectedRow.AcctRestrict">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Stop Price</mat-label>
                      <input matInput placeholder="Stop Price" disabled [(ngModel)]="selectedRow.StopPrice">
                    </mat-form-field>
                  </ng-container>
                  <ng-container>
                    <h2><span>Order Details</span></h2>
                    <mat-form-field>
                      <mat-label>OMS System</mat-label>
                      <input matInput placeholder="OMS System" disabled [(ngModel)]="selectedRow.OMSSystem">
                    </mat-form-field>
          
                    <mat-form-field [style.width.px]=350>
                      <mat-label>Order Id </mat-label>
                      <input matInput placeholder="Order Id" disabled [(ngModel)]="selectedRow.OrderID">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Order Desk</mat-label>
                      <input matInput placeholder="Order Desk" disabled [(ngModel)]="selectedRow.OrderDesk">
                    </mat-form-field>
          
                    <mat-form-field>
                      <mat-label>Received From MPID</mat-label>
                      <input matInput placeholder="Recieved From MPID" disabled
                        [(ngModel)]="selectedRow.ReceivedFromMPID">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Originating Desk</mat-label>
                      <input matInput placeholder="Originating Desk" disabled [(ngModel)]="selectedRow.OriginatingDesk">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Received Order Id</mat-label>
                      <input matInput placeholder="Recieved Order Id" disabled [(ngModel)]="selectedRow.ReceivedOrderId">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Terminal User</mat-label>
                      <input matInput placeholder="Terminal User" disabled [(ngModel)]="selectedRow.TerminalUser">
                    </mat-form-field>
                  </ng-container>
                  <ng-container>
                    <h2><span>Order Instructions</span></h2>
                    <mat-form-field>
                      <mat-label>All Or None</mat-label>
                      <input matInput placeholder="All Or None" disabled [(ngModel)]="selectedRow.AllOrNone">
                    </mat-form-field>
          
                    <mat-form-field>
                      <mat-label>Cancel By Cust</mat-label>
                      <input matInput placeholder="Cancel By Cust" disabled [(ngModel)]="selectedRow.CancelByCust">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Spl Handling Code</mat-label>
                      <input matInput placeholder="Spl Handling Code" disabled [(ngModel)]="selectedRow.SplHandlingCode">
                    </mat-form-field>
          
                    <mat-form-field>
                      <mat-label>Delivery Instructions</mat-label>
                      <input matInput placeholder="Delivery Instructions" disabled
                        [(ngModel)]="selectedRow.DeliveryInstructions">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Not Held</mat-label>
                      <input matInput placeholder="Not Held" disabled [(ngModel)]="selectedRow.NotHeld">
                    </mat-form-field>
          
                    <mat-form-field>
                      <mat-label>Do Not Reduce Increase</mat-label>
                      <input matInput placeholder="Do Not Reduce Increase" disabled
                        [(ngModel)]="selectedRow.DoNotReduceIncrease">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Limit Order Display</mat-label>
                      <input matInput placeholder="Limit Order Display" disabled
                        [(ngModel)]="selectedRow.LimitOrderDisplay">
                    </mat-form-field>
          
                    <mat-form-field>
                      <mat-label>Program Trading</mat-label>
                      <input matInput placeholder="Program Trading" disabled [(ngModel)]="selectedRow.ProgramTrading">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Negotiated Trade</mat-label>
                      <input matInput placeholder="Negotiated Trade" disabled [(ngModel)]="selectedRow.NegotiatedTrade">
                    </mat-form-field>
          
                    <mat-form-field>
                      <mat-label>Strategy</mat-label>
                      <input matInput placeholder="Strategy" disabled [(ngModel)]="selectedRow.Strategy">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Strategy Details</mat-label>
                      <input matInput placeholder="Strategy Details" disabled [(ngModel)]="selectedRow.StrategyDetails">
                    </mat-form-field>
          
                    <mat-form-field>
                      <mat-label>Trade Along(%)</mat-label>
                      <input matInput placeholder="Trade Along(%)" disabled [(ngModel)]="selectedRow.TradeAlong">
                    </mat-form-field>
                  </ng-container>
                </div>
                </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel value="1">
              <p-accordion-header><span class="headerText">Exception Data</span></p-accordion-header>
              <p-accordion-content>            
                <div class="div-scroll1">
                <div class="col-xs-12 col-lg-12 col-md-12 col-sm-12">
                  <div class="col-md-4 box-border min-hg-184" style="font-size: 14px !important;">
                    No Market data
                  </div>
                  <div class="col-xs-8 col-lg-8 col-md-8 box-border min-hg-184">
                    <div class="row"> <label for="exceptionList" class="head-color"> Exception List</label></div>
                    <div class="row">
                      <div class="col-xs-12 col-lg-12 col-md-12 col-sm-12  nopadding sm-table-container table-full-min-width">
                        @if(loading.isExceptionLoading){
                        <div class="example-loading-shade">
                          <mat-spinner></mat-spinner>
                        </div>
                        }
                        <p-table [columns]="ExceptionGridCols" [value]="exceptionList" [paginator]="exceptionList.length >3 ? true: false" [rows]="3"
                          [lazy]="true">
                            <ng-template pTemplate="header" let-columns>
                              <tr>
                                @for(col of columns; track col.header + '-'+ $index;) {
                                <th id="colHeader">
                                  {{col.header}}
                                </th>
                                }
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns">
                              <tr>
                                @for(col of columns; track col.field + '-'+ $index;) {
                                <td>
                                  {{rowData[col.field]}}
                                </td>
                                }
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="paginatorright">
                              Total Records: {{exceptionList.length == 0? 0 : exceptionList.length}}
                  
                            </ng-template>
                            <ng-template pTemplate="paginatorleft">
                            </ng-template>
                          </p-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>

          <mat-accordion #accordion="matAccordion" multi>
            <div class="showData-div">
              <mat-checkbox color="primary" id="order" [(ngModel)]="isOrder">Order</mat-checkbox>
              <mat-checkbox color="primary" id="trade" [(ngModel)]="isTrade">Trade</mat-checkbox>
              <mat-checkbox color="primary" id="route" [(ngModel)]="isRoute">Route</mat-checkbox>
              <button type="button" class="btn-DodgerBlue mg-l-10" id="Show_all" (click)="isOrder=true;isTrade=true;isRoute=true">Show All</button>
              <button type="button" class="btn-DodgerBlue mg-l-10" id="hideAll" (click)="isOrder=false;isTrade=false;isRoute=false">Hide All</button>
            </div>
            <mat-expansion-panel [expanded]="isOrder" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span class="exception-panel-title"> Order Data</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-panel-description>
                <div class="col-xs-12 col-lg-12 col-md-12  nopadding table-container table-full-min-width">
                  @if(loading.isOrderDataLoading){
                  <div class="example-loading-shade">
                    <mat-spinner></mat-spinner>
                  </div>
                  }
                  <app-turbo-table [GridColumns]="OrderGridCols" [Dataset]="orderData" [TotalRecords]=orderData.length>
                  </app-turbo-table>
                </div>
              </mat-panel-description>
            </mat-expansion-panel>
            <mat-expansion-panel [expanded]="isRoute">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span class="exception-panel-title"> Route Data</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-panel-description>
                <div class="col-xs-12 col-lg-12 col-md-12  nopadding table-container table-full-min-width">
                  @if(loading.isRouteDataLoading){
                  <div class="example-loading-shade">
                    <mat-spinner></mat-spinner>
                  </div>
                  }
                  <app-turbo-table [GridColumns]="RouteGridCols" [Dataset]="routeData" [TotalRecords]=routeData.length>
                  </app-turbo-table>
                </div>
              </mat-panel-description>
            </mat-expansion-panel>
            <mat-expansion-panel  [expanded]="isTrade">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span class="exception-panel-title">Trade Data</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-panel-description>
                <div class="col-xs-12 col-lg-12 col-md-12  nopadding table-container table-full-min-width">
                  @if(loading.isTradeDataLoading){
                  <div class="example-loading-shade">
                    <mat-spinner></mat-spinner>
                  </div>
                  }
                  <app-turbo-table [GridColumns]="TradeGridCols" [Dataset]="tradeData" [TotalRecords]=tradeData.length>
                  </app-turbo-table>
                </div>
              </mat-panel-description>
            </mat-expansion-panel>
          </mat-accordion>
      </div>
        
      </div>
</p-dialog> 
